import type { Dayjs } from 'dayjs';

export const UPDATE_FIXED_START = 'listingDetailsDates/UPDATE_FIXED_START';
export const UPDATE_FIXED_END = 'listingDetailsDates/UPDATE_FIXED_END';
export const UPDATE_MONTHLY_START = 'listingDetailsDates/UPDATE_MONTHLY_START';
export const UPDATE_MONTHLY_TYPE = 'listingDetailsDates/UPDATE_MONTHLY_TYPE';

export const initialDatesState = {
  monthly: {
    startDateTime: null,
    monthlyType: 'WEEKDAYS_ONLY'
  },
  fixedTerm: {
    startDateTime: null,
    endDateTime: null
  }
};

export type Dates = {
  monthly: {
    startDateTime: ?Dayjs,
    monthlyType: string
  },
  fixedDates: {
    startDateTime: ?Dayjs,
    endDateTime: ?Dayjs
  }
};

export const actions = {
  updateFixedStartDate: (date) => ({
    type: UPDATE_FIXED_START,
    date
  }),
  updateFixedEndDate: (date) => ({
    type: UPDATE_FIXED_END,
    date
  }),
  updateMonthlyStartDate: (date) => ({
    type: UPDATE_MONTHLY_START,
    date
  }),
  updateMonthlyType: (data) => ({
    type: UPDATE_MONTHLY_TYPE,
    data
  })
};

export const datesReducer = (state, action) => {
  switch (action.type) {
    case UPDATE_FIXED_START:
      return {
        ...state,
        fixedTerm: {
          ...state.fixedTerm,
          startDateTime: action.date
        }
      };
    case UPDATE_FIXED_END:
      return {
        ...state,
        fixedTerm: {
          ...state.fixedTerm,
          endDateTime: action.date
        }
      };
    case UPDATE_MONTHLY_START:
      return {
        ...state,
        monthly: {
          ...state.monthly,
          startDateTime: action.date
        }
      };
    case UPDATE_MONTHLY_TYPE:
      return {
        ...state,
        monthly: {
          ...state.monthly,
          monthlyType: action.data
        }
      };
    default:
      throw new Error('Action not defined');
  }
};
